import { IconSvg, IconSvgProps } from "./icon"

export default function Play(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 0 1 0 1.971l-11.54 6.347a1.125 1.125 0 0 1-1.667-.985V5.653Z" />
    </IconSvg>
  )
}
